import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";

/*eslint-disable */
declare const window: any;

interface MenuVehiculosDetailComponentProps {
  selectedMenu: any;
  navigate: any;
  setSelectedMenu: any;
  data: any;
  visibleHeight: any;
  ficha_tecnica: any;
  menus: any;
  currentSection: any;
  vehiculo: any;
  topbar_design: any;
  topbar_gallery: any;
  topbar_models: any;
  topbar_technology: any;
  topbar_version: any;
  brochures: any;
}

const MenuVehiculosDetailComponent: React.FC<
  MenuVehiculosDetailComponentProps
> = ({
  selectedMenu,
  navigate,
  setSelectedMenu,
  data,
  visibleHeight,
  ficha_tecnica,
  menus,
  currentSection,
  vehiculo,
  topbar_design,
  topbar_gallery,
  topbar_models,
  topbar_technology,
  topbar_version,
  brochures ,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, maxHeight: 'auto' });
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const mediaQuery = window.matchMedia("(max-width: 1000px)");

      const handleChange = () => {
        setIsMobile(mediaQuery.matches);
      };

      handleChange();

      mediaQuery.addEventListener("change", handleChange);

      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    }, []);

    return isMobile;
  };

  const isMobile = useIsMobile();

  const calculateDropdownPosition = () => {
    if (buttonRef.current && isMobile) {
      const rect = buttonRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const dropdownHeight = 150;
      
      let top = rect.bottom + window.scrollY;
      let maxHeight = 'auto';
      
      if (rect.bottom + dropdownHeight > viewportHeight) {
        top = rect.top + window.scrollY - dropdownHeight;
        maxHeight = `${rect.top - 10}px`;
      }
      
      let left = rect.left + window.scrollX;
      const dropdownWidth = 220;
      
      if (left + dropdownWidth > window.innerWidth) {
        left = window.innerWidth - dropdownWidth - 10;
      }
      
      if (left < 10) {
        left = 10;
      }
      
      setDropdownPosition({
        top,
        left,
        maxHeight: maxHeight !== 'auto' ? maxHeight : 'auto'
      });
    }
  };

  useEffect(() => {
    if (showDropdown && isMobile) {
      setTimeout(calculateDropdownPosition, 10);
      
      window.addEventListener('scroll', calculateDropdownPosition);
      window.addEventListener('resize', calculateDropdownPosition);
      
      return () => {
        window.removeEventListener('scroll', calculateDropdownPosition);
        window.removeEventListener('resize', calculateDropdownPosition);
      };
    }
  }, [showDropdown, isMobile]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (buttonRef.current && buttonRef.current.contains(target)) {
        return;
      }
      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleFichaClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (brochures.length > 1) {
      setShowDropdown(!showDropdown);
    } else if (brochures.length === 1) {
      window.open(brochures[0].brochure_url, "_blank");
      setSelectedMenu("ficha");
    } else if (ficha_tecnica) {
      window.open(ficha_tecnica, "_blank");
      setSelectedMenu("ficha");
    } else {
      navigate("#ficha");
      setSelectedMenu("ficha");
    }
  };

  const handleVersionSelect = (url: string) => {
    window.open(url, "_blank");
    setSelectedMenu("ficha");
    setShowDropdown(false);
  };

  const hasMultipleBrochures = brochures.length > 1;

  const renderDropdown = () => {
    if (!hasMultipleBrochures || !showDropdown) return null;
    
    const dropdownContent = (
      <div 
        ref={dropdownRef}
        className={`ficha-tecnica-dropdown ${isMobile ? 'mobile portal-dropdown' : ''}`}
        style={isMobile ? {
          position: 'fixed',
          top: `${dropdownPosition.top}px`,
          left: `${dropdownPosition.left}px`,
          zIndex: 10000,
          minWidth: '200px',
          maxWidth: '280px',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
          border: '1px solid #E5E5E5',
          overflow: 'hidden',
          maxHeight: dropdownPosition.maxHeight !== 'auto' ? dropdownPosition.maxHeight : 'auto',
          overflowY: 'auto'
        } : {
          position: 'absolute',
          top: '100%',
          left: '0',
          minWidth: '220px',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          border: '1px solid #E5E5E5',
          marginTop: '5px',
          zIndex: 1000,
          overflow: 'hidden'
        }}
      >
        {brochures.map((brochure: any, index: number) => (
          <button
            key={index}
            className="ficha-tecnica-dropdown-item"
            onClick={() => handleVersionSelect(brochure.brochure_url)}
            style={{
              width: '100%',
              padding: '12px 20px',
              textAlign: 'left',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              font: "normal normal 500 14px/18px 'Hyundai Sans Head KR Medium', sans-serif",
              color: '#4A4A4A',
              transition: 'all 0.2s ease',
              borderBottom: index !== brochures.length - 1 ? '1px solid #F0F0F0' : 'none',
              fontSize: '14px',
              lineHeight: '1.4'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#F5F5F5';
              e.currentTarget.style.color = '#002E6B';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#4A4A4A';
            }}
          >
            {brochure.brochure_name}
          </button>
        ))}
      </div>
    );
    
    if (isMobile) {
      return ReactDOM.createPortal(dropdownContent, document.body);
    }
    
    return dropdownContent;
  };

  return (
    <div
      className="menu-vehiculos-detail-component"
      style={visibleHeight <= 0 ? { top: `0px` } : {}}
    >
      <div className="title-menu-vehiculos-detail-component">{data.title}</div>
      <div className="content-menu-vehiculos-detail-component">
        {isMobile && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "cotizacion" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#cotizacion`);
              setSelectedMenu("cotizacion");
            }}
          >
            Cotización
          </div>
        )}
        
        <div 
          className="ficha-tecnica-dropdown-container"
          style={{ position: 'relative', display: 'inline-block' }}
        >
          <div
            ref={buttonRef}
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "ficha" ? "active" : ""
            }`}
            onClick={handleFichaClick}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            Ficha técnica
            {hasMultipleBrochures && (
              <span className="dropdown-arrow" style={{ 
                marginLeft: '4px', 
                display: 'inline-flex',
                transition: 'transform 0.2s ease',
                transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)'
              }}>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            )}
          </div>
          
          {renderDropdown()}
        </div>

        {menus.motor && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "motor" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#motor`);
              setSelectedMenu("motor");
            }}
          >
            Motor
          </div>
        )}

        <div
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "diseño" ? "active" : ""
          }`}
          onClick={() => {
            navigate(`/vehiculos/${vehiculo}#diseno`);
            setSelectedMenu("diseño");
          }}
        >
          {topbar_design}
        </div>
        {menus.version && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "versiones" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#versiones`);
              setSelectedMenu("versiones");
            }}
          >
            {topbar_version}
          </div>
        )}
        {menus.galeria && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "galeria" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#galeria`);
              setSelectedMenu("galeria");
            }}
          >
            {topbar_gallery}
          </div>
        )}
        {menus.tecnologia && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "tecnologia" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#tecnologia`);
              setSelectedMenu("tecnologia");
            }}
          >
            {topbar_technology}
          </div>
        )}
        {menus.modelos && (
          <div
            className={`individual-content-menu-vehiculos-detail-component ${
              selectedMenu === "modelos" ? "active" : ""
            }`}
            onClick={() => {
              navigate(`/vehiculos/${vehiculo}#modelos`);
              setSelectedMenu("modelos");
            }}
          >
            {topbar_models}
          </div>
        )}
        <Link
          to={`/vehiculos/${vehiculo}/comparador`}
          className={`individual-content-menu-vehiculos-detail-component ${
            selectedMenu === "comparador" ? "active" : ""
          }`}
          onClick={() => {
            navigate("#comparador");
            setSelectedMenu("comparador");
          }}
        >
          Comparador
        </Link>
      </div>
      <div className="opciones-menu-vehiculos-detail-component">
        <Link
          to={`/simulador-de-cuotas/${data.modelo}`}
          className="simulador-opciones-menu-vehiculos-detail-component"
        >
          Simula tu cuota
        </Link>
        <Link
          to={`/vehiculos/${data.modelo}#cotizacion`}
          className="cotiza-opciones-menu-vehiculos-detail-component"
        >
          Cotiza
        </Link>
      </div>
    </div>
  );
};

export default MenuVehiculosDetailComponent;